import "./style.scss";
import { useElementCssHeight } from "@hook";
import { sendMetric, getWhatId } from "@utils";
import { inject, observer } from "mobx-react";
import { useRef } from "react";

const { VITE_WHAT_ID } = import.meta.env;

const Default = inject("mainStore")(
    observer(({ mainStore }) => {
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;
        const footerRef = useRef(null);

        useElementCssHeight(footerRef, "--footer-height");

        const policyHandler = (e) => {
            if (e.button == 0 || e.button == 1) {
                sendMetric(`click_footer_privacy`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: null,
                    params8: what_id,
                });
            }
        };

        const mailHandler = (e) => {
            sendMetric(`click_footer_email`, {
                params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                params2: null,
                params3: null,
                params4: null,
                params6: null,
                params7: null,
                params8: what_id,
            });
        };

        return (
            <div className="footer" ref={footerRef}>
                <div className="footer__block">
                    <div className="block__privacy cursor">
                        <a href="https://ris.promo/pdf/privacy.pdf" target="_blank" onMouseDown={(e) => policyHandler(e)} rel="noreferrer">
                            Политика конфиденциальности
                        </a>
                    </div>

                    <div className="block__privacy cursor">
                        <a href="https://ris.promo/pdf/offer.pdf" target="_blank" onMouseDown={(e) => policyHandler(e)} rel="noreferrer">
                            Публичная оферта
                        </a>
                    </div>

                    <div className="block__text ">
                        Если возникли вопросы обращайтесь на{" "}
                        <a href="mailto:info@ris.promo" target="_blank" onClick={mailHandler} className="cursor" rel="noreferrer">
                            info@ris.promo
                        </a>
                    </div>

                    <div className="block__privacy cursor">
                        <a href="https://about.ris.promo/" target="_blank" rel="noreferrer">
                            Оставить заявку на сотрудничество
                        </a>
                    </div>
                </div>
            </div>
        );
    }),
);

export default Default;
